import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useProgress } from '../contexts/ProgressContext';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';

const Dashboard = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const { progress } = useProgress();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
    } else {
      setLoading(false);
    }
  }, [isAuthenticated, navigate]);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const totalProgress = progress?.totalProgress || 0;

  if (loading) {
    return (
      <div className="dashboard-container">
        <div className="loading">Chargement...</div>
      </div>
    );
  }

  return (
    <div className="dashboard-layout">
      {/* SIDEBAR PRO */}
      <aside className="dashboard-sidebar">
        {/* Logo */}
        <div className="sidebar-logo" onClick={() => navigate('/dashboard')}>
          <span className="logo-text">F12IA</span>
          <span className="logo-tm">™</span>
        </div>

        {/* User Profile Mini */}
        <div className="sidebar-user">
          <div className="user-avatar">
            {user?.firstName?.charAt(0).toUpperCase() || 'U'}
          </div>
          <div className="user-info">
            <span className="user-name">{user?.firstName || 'Utilisateur'}</span>
            <span className="user-role">Membre</span>
          </div>
        </div>

        {/* Main Navigation */}
        <nav className="sidebar-nav-pro">
          <div className="nav-label">MENU</div>

          <div
            className="nav-item active"
            onClick={() => navigate('/dashboard')}
          >
            <span className="nav-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="3" width="7" height="7" rx="1"/>
                <rect x="14" y="3" width="7" height="7" rx="1"/>
                <rect x="3" y="14" width="7" height="7" rx="1"/>
                <rect x="14" y="14" width="7" height="7" rx="1"/>
              </svg>
            </span>
            <span className="nav-text">Tableau de bord</span>
          </div>

          <div className="nav-label">FORMATIONS</div>

          <div
            className="nav-item"
            onClick={() => navigate('/formation/chatgpt')}
          >
            <span className="nav-icon chatgpt-icon">
              <img src="/chatgpt-logo.png" alt="ChatGPT" style={{width: '20px', height: '20px', objectFit: 'contain'}} />
            </span>
            <span className="nav-text">ChatGPT</span>
          </div>

          <div
            className="nav-item"
            onClick={() => navigate('/formation/claude')}
          >
            <span className="nav-icon claude-icon">
              <img src="/claude-logo.png" alt="Claude" style={{width: '20px', height: '20px', objectFit: 'contain'}} />
            </span>
            <span className="nav-text">Claude Code</span>
          </div>

          <div
            className="nav-item fusion-nav"
            onClick={() => navigate('/formation/fusion')}
          >
            <span className="nav-icon fusion-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M13 10V3L4 14h7v7l9-11h-7z"/>
              </svg>
            </span>
            <span className="nav-text">Fusion</span>
            <span className="nav-badge-pro">PRO</span>
          </div>

          <div className="nav-label">COMPTE</div>

          <div
            className="nav-item"
            onClick={() => navigate('/profile')}
          >
            <span className="nav-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="8" r="4"/>
                <path d="M4 20c0-4 4-6 8-6s8 2 8 6"/>
              </svg>
            </span>
            <span className="nav-text">Mon profil</span>
          </div>

          <div
            className="nav-item"
            onClick={() => navigate('/resources')}
          >
            <span className="nav-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                <path d="M2 17l10 5 10-5"/>
                <path d="M2 12l10 5 10-5"/>
              </svg>
            </span>
            <span className="nav-text">Ressources</span>
          </div>

          <div
            className="nav-item"
            onClick={() => navigate('/certificate')}
          >
            <span className="nav-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="8" r="6"/>
                <path d="M8 14l-2 8 6-3 6 3-2-8"/>
              </svg>
            </span>
            <span className="nav-text">Certificat</span>
          </div>
        </nav>

        {/* Progress Section */}
        <div className="sidebar-progress-pro">
          <div className="progress-header">
            <span className="progress-title">Progression</span>
            <span className="progress-value">{Math.round(totalProgress)}%</span>
          </div>
          <div className="progress-bar-pro">
            <div
              className="progress-fill-pro"
              style={{ width: `${totalProgress}%` }}
            />
          </div>
        </div>

        {/* Logout Button - Bottom */}
        <div className="sidebar-bottom">
          <div className="nav-item logout-item" onClick={handleLogout}>
            <span className="nav-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                <polyline points="16 17 21 12 16 7"/>
                <line x1="21" y1="12" x2="9" y2="12"/>
              </svg>
            </span>
            <span className="nav-text">Deconnexion</span>
          </div>
        </div>
      </aside>

      {/* MAIN CONTENT */}
      <main className="dashboard-main">
        {/* Top Bar */}
        <div className="dashboard-topbar">
          <div className="topbar-left">
            <h1 className="page-title">Tableau de bord</h1>
          </div>
          <div className="topbar-right">
            <span className="welcome-text">Bienvenue, <strong>{user?.firstName}</strong></span>
          </div>
        </div>

        <div className="dashboard-content">
          {/* Hero Section */}
          <div className="hero-section">
            <div className="hero-content">
              <span className="hero-badge">FORMATIONS IA</span>
              <h2>Maitrisez l'IA en quelques heures</h2>
              <p>Trois parcours complets pour devenir expert des outils IA les plus puissants.</p>
            </div>
          </div>

          {/* AI Cards Grid */}
          <div className="ai-cards-grid">
            {/* ChatGPT Card */}
            <div className="ai-card chatgpt-card" onClick={() => navigate('/formation/chatgpt')}>
              <div className="ai-card-glow"></div>
              <div className="ai-card-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4944zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.8956zm16.5963 3.8558L13.1038 8.364l2.0201-1.1638a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.4091-.6813zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.142.0805L8.704 5.459a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654l2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z" fill="#10a37f"/>
                </svg>
              </div>
              <h3>ChatGPT</h3>
              <p>Assistant IA pour le quotidien</p>
              <div className="ai-card-arrow">→</div>
            </div>

            {/* Claude Card */}
            <div className="ai-card claude-card" onClick={() => navigate('/formation/claude')}>
              <div className="ai-card-glow"></div>
              <div className="ai-card-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.709 15.955l4.72-2.647.08-.23-.08-.128-2.251-3.614-.144-.072-4.794.893-.071.158.503 2.332.014.13 2.023 3.178zm7.19-7.553L14.9 4.5l-.087-.197-2.302-.485-.123.037-2.153 3.69.033.164 1.515 1.02.116-.026zm-5.98 5.408l-.043-.082-1.628-.357-.12.052-.71 2.468.03.103 1.26.327.094-.024 1.31-1.73-.072-.439-.12-.318zm10.864-5.334l.228-.152-.014-.182-1.933-1.269-.173.014-.787 1.19.024.18 1.29 1.232.152-.015.07-.062 1.143-.936zm.566 3.592l-3.054-.952-.193.082-.076.176.803 3.982.112.082 2.993-.567.096-.117-.178-2.462-.136-.15-.367-.074zM8.67 7.142l-.164-.068-1.792.674-.054.148 1.18 1.775.163.052 1.627-.902.048-.162-.629-1.385-.379-.132zm5.7 8.211l-.188-.031-1.487 1.235-.014.185.91 1.17.184.026 1.426-1.225.032-.172-.862-1.188zm-1.42-4.048l-.241-.11-3.116 1.764-.053.238.993 1.607.226.065 3.24-1.628.068-.239-1.118-1.697zm-4.313-.12l-.131-.037-.697.366-.02.125.433.678.127.042.702-.37.024-.127-.438-.678z" fill="#cc785c"/>
                  <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z" fill="#cc785c"/>
                </svg>
              </div>
              <h3>Claude Code</h3>
              <p>Developpeur IA dans ton terminal</p>
              <div className="ai-card-arrow">→</div>
            </div>

            {/* Fusion Card */}
            <div className="ai-card fusion-card-new" onClick={() => navigate('/formation/fusion')}>
              <div className="ai-card-glow"></div>
              <span className="card-badge-pro">PRO</span>
              <div className="ai-card-icon fusion-icons">
                {/* Logo ChatGPT Original */}
                <svg className="fusion-svg-left" viewBox="0 0 24 24" fill="none">
                  <path d="M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4944zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.8956zm16.5963 3.8558L13.1038 8.364l2.0201-1.1638a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.4091-.6813zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.142.0805L8.704 5.459a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654l2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z" fill="#10a37f"/>
                </svg>
                <span className="fusion-plus-icon">+</span>
                {/* Logo Claude Original */}
                <svg className="fusion-svg-right" viewBox="0 0 24 24" fill="none">
                  <path d="M4.709 15.955l4.72-2.647.08-.23-.08-.128-2.251-3.614-.144-.072-4.794.893-.071.158.503 2.332.014.13 2.023 3.178zm7.19-7.553L14.9 4.5l-.087-.197-2.302-.485-.123.037-2.153 3.69.033.164 1.515 1.02.116-.026zm-5.98 5.408l-.043-.082-1.628-.357-.12.052-.71 2.468.03.103 1.26.327.094-.024 1.31-1.73-.072-.439-.12-.318zm10.864-5.334l.228-.152-.014-.182-1.933-1.269-.173.014-.787 1.19.024.18 1.29 1.232.152-.015.07-.062 1.143-.936zm.566 3.592l-3.054-.952-.193.082-.076.176.803 3.982.112.082 2.993-.567.096-.117-.178-2.462-.136-.15-.367-.074zM8.67 7.142l-.164-.068-1.792.674-.054.148 1.18 1.775.163.052 1.627-.902.048-.162-.629-1.385-.379-.132zm5.7 8.211l-.188-.031-1.487 1.235-.014.185.91 1.17.184.026 1.426-1.225.032-.172-.862-1.188zm-1.42-4.048l-.241-.11-3.116 1.764-.053.238.993 1.607.226.065 3.24-1.628.068-.239-1.118-1.697zm-4.313-.12l-.131-.037-.697.366-.02.125.433.678.127.042.702-.37.024-.127-.438-.678z" fill="#cc785c"/>
                </svg>
              </div>
              <h3>Fusion</h3>
              <p>La puissance des deux combinés</p>
              <div className="ai-card-arrow">→</div>
            </div>
          </div>

          {/* Stats Grid */}
          <div className="stats-grid-pro">
            <div className="stat-card-pro">
              <div className="stat-icon-pro">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                  <path d="M2 17l10 5 10-5"/>
                  <path d="M2 12l10 5 10-5"/>
                </svg>
              </div>
              <div className="stat-content">
                <span className="stat-number">3</span>
                <span className="stat-label">Parcours</span>
              </div>
            </div>

            <div className="stat-card-pro">
              <div className="stat-icon-pro">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                  <polyline points="14 2 14 8 20 8"/>
                  <line x1="16" y1="13" x2="8" y2="13"/>
                  <line x1="16" y1="17" x2="8" y2="17"/>
                </svg>
              </div>
              <div className="stat-content">
                <span className="stat-number">30+</span>
                <span className="stat-label">Prompts</span>
              </div>
            </div>

            <div className="stat-card-pro">
              <div className="stat-icon-pro">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                  <line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
              </div>
              <div className="stat-content">
                <span className="stat-number">10+</span>
                <span className="stat-label">Quiz</span>
              </div>
            </div>

            <div className="stat-card-pro">
              <div className="stat-icon-pro gold">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="8" r="6"/>
                  <path d="M8 14l-2 8 6-3 6 3-2-8"/>
                </svg>
              </div>
              <div className="stat-content">
                <span className="stat-number">1</span>
                <span className="stat-label">Certificat</span>
              </div>
            </div>
          </div>

          {/* Certificate CTA */}
          {totalProgress >= 80 && (
            <div className="certificate-cta-pro" onClick={() => navigate('/certificate')}>
              <div className="cta-icon">🎓</div>
              <div className="cta-content">
                <h4>Vous y etes presque !</h4>
                <p>Completez les quiz pour obtenir votre certificat F12IA</p>
              </div>
              <div className="cta-arrow">→</div>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default Dashboard;
